import { ITreeNodeModel } from "../../../../../Components/TreeView/Models/Interfaces/ITreeNodeModel";
import { app } from "../../../../../Frame/App";

export function sortContent(a: ITreeNodeModel, b: ITreeNodeModel): number {
    if (a.businessModel.pos > b.businessModel.pos) {
        return 1;
    } else if (a.businessModel.pos < b.businessModel.pos) {
        return -1;
    }

    if ((a.businessModel.nameAll["value" + app.languageUpperCase] ?? a.businessModel.nameAll["value" + app.defaultLanguageUpperCase]) < (b.businessModel.nameAll["value" + app.languageUpperCase] ?? b.businessModel.nameAll["value" + app.defaultLanguageUpperCase])) {
        return -1;
    } else if ((a.businessModel.nameAll["value" + app.languageUpperCase] ?? a.businessModel.nameAll["value" + app.defaultLanguageUpperCase]) > (b.businessModel.nameAll["value" + app.languageUpperCase] ?? b.businessModel.nameAll["value" + app.defaultLanguageUpperCase])) {
        return 1;
    } else {
        return 0;
    }
}